import React from 'react';

class ServiceDeleteLocalStorage {

  async removeItemValue() {
    try {
      await localStorage.removeItem('@AsyncStorage:app_archers_token');
      return true;
    } catch (exception) {
      return false;
    }
  }

}
export default new ServiceDeleteLocalStorage();
